import { render } from "./login.vue?vue&type=template&id=2ba447d2&scoped=true"
import script from "./login.vue?vue&type=script&lang=js"
export * from "./login.vue?vue&type=script&lang=js"

import "./login.vue?vue&type=style&index=0&id=2ba447d2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2ba447d2"

export default script